module.exports={
    label: {
        all: 'All sizes',
        search:'Search',
        updateAll:'Update All',
        bindUpdateAll:'Bind All',
        rebind:'Unbound Rebind',
        upgradeAll:'Upgrade All',
        import:'Import',
        // bindUpdatePart:'绑 定',
        // rouseAll:'唤 醒',
        // deleteAll:'删 除',
        queryText:'Size',
        submiting: 'Submitting...',
        operation:{
            operation:'Operation',
            more:'More',
            bindUpdatePart:'Bind',
            rouseAll:'Wake up',
            deleteAll:'Delete',
            downloadLabel:'Download ESL',
            downloadBind:'Download Bind',
            batchUpdate:'Update',
            reset:'Reset',
            upgradeESL:'Upgrade',
            importBinding:'Import Bind'
        },
        table:{     //标签信息
        	index:'Number',
        	mac:'MAC Address',
        	screenSize:' Size(")',
        	battery:'Battery level(%)',
        	lastupdate:'Last communication time',
        	updateTime:'Last update time',
        	gatewayMac:'Gateway binding',
        	onlineStatus:'Status',
        	operation:'Operation',
            bindUpdate:'Bind',
        	rouse:'Wake up',
        	delete:'Delete',
            online:'Online',
            offline:'Offline'
        },
        table2:{
            operation:'Operation',
            update:'Modify',
            delete:'Delete'
        },
        equipmentInfo:'Device Information',
        devices:{   //设备信息
            Manufacturer:'Manufacturer:',
            battery:'Battery level:',
            temperature:'Temperature:',
            runningTime:'Running time:',
            rssi:'RSSI@1m:',
            firmwareVersion:'Firmware version:',
            hardwareVersion:'Hardware version:',
            screenInfo:'Screen info:',
            chipInfo:'Chip info:',
            // screenInfos:[
            // {
            //     key:'0001',
            //     value:'1.54"(152*152) black and white',
            //     size:'1.54',
            //     rotate:''
            // },{
            //     key:'0002',
            //     value:'2.13"(212*104) black and white',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0003',
            //     value:'2.13"(250*122) black and white',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0004',
            //     value:'2.9"(296*128) black and white',
            //     size:'2.9',
            //     rotate:''
            // },{
            //     key:'0005',
            //     value:'4.2"(300*400) black and white',
            //     size:'4.2',
            //     rotate:''
            // }],
            hardwareInfos:[
            {
                key:'0001',
                value:'MO95SF6_V1.0'
            },{
                key:'0002',
                value:'MS107F6_V1.0'
            },{
                key:'0003',
                value:'MS105F6_V1.4'
            },{
                key:'0004',
                value:'MS106F6_V1.0'
            },{
                key:'0005',
                value:'MS116F6_V1.0'
            },{
                key:'0006',
                value:'MS117F6_V1.0'
            },{
                key: '0007',
                value: 'MS127F6_V1.0'
            },{
                key:"0008",
                value:"MS128F6_V1.0"
            },{
                key:"0009",
                value:"MS134F6_V1.0"
            },{
                key:"000A",
                value:"MS132F6_V1.0"
            }],
            chipInfos:[
            {
                key:'01',
                value:'Nordic Semi, nRF52810'
            }]

        	// mac:'MAC Address:',
        	// type:'Model:',
        	// screenSize:'Screen size:',
        	// battery:'Battery level:',
        	// software:'Software version:',
        	// protocolStack:'SoftDevice Specification:',
        	// manufacturer:'Manufacturer:',
        	// hardware:'Hardware version:',
        	// heartbeat:'Broadcast duration:'
        	// upgrade:'升 级',
        },
        isHaveGateway:'Please add a gateway first',
        preview:'Preview',
        bindProducts:'Bound Product',
        cancel:'Cancel',
        sure:'OK',
        hint:'Prompt',
        labelLight:{   //标签灯
            green1:'/static/images/label_green_1.png',
            green2:'/static/images/label_green_2.png',
            blue1:'/static/images/label_blue_1.png',
            blue2:'/static/images/label_blue_2.png',
            red1:'/static/images/label_red_1.png',
            red2:'/static/images/label_red_2.png'
        },
        labelLightMsg:{   //标签灯提示信息
            green:'Bright green light',
            red:'Bright red light',
            blue:'Bright blue light',
            success:'ESL {mac}:The {color} light command was sent successfully.',
            fail:'ESL {mac}:The {color} light command was sent failed.',
            unbind:'ESL {mac}:Current ESL is not bound to the gateway',
            noLabel:'ESL {mac}:Current ESL does not exist',
            chooseLabel:'Please select the ESL to be lit',
            color:[{
                key:'1',
                value:'blue'
            },{
                key:'2',
                value:'green'
            },{
                key:'3',
                value:'red'
            }]
        },
        bindRelation:{   //绑定商品-新增和修改绑定关系
            title:'Bind',
            title2:'Modify',
            add:'Add template',
            del:'Delete',
            save:'Save',
            saving:'Saving...',
            id:'ID:',
            templates:'Template:',
            placeholder1:'Please enter the ID of the products',
            templateType:{
                common:'Commonly used',
                promotion:'Promotion',
                activity:'Activity'
            },
            effect:{
                valid:'Valid',
                invalid:'Invalid'
            },
            limitMsg:'The bound template has reached 7 caps and cannot be added anymore.',
            getTemplateFail:'Failed to get all templates for this size! Please re-operate',
            noTemplate:'Template does not exist',
            noLabel:'ESL does not exist',
            noProduct:'Without this product information, please import or add first',
            success:'Binding success',
            modifySuccess:'Modify the binding successfully',
            fail:'Binding failed',
            delFail:'Delete failed',
            noBind:'No binding gateway',
            tip:{
                product:'ID',
                label:'ESL',
                template:'Template Name'
            },
            validate:{
                id:'Please enter the ID of the products',
                isNum:"Please enter a letter or number",
                noTemplates:'Please select a template',
                noTemplatesData:'The ESL does not have a template of the corresponding size',
                bindGateway:'Please bind the ESL to the gateway first',
                noPermission: 'You do not have permission to view templates'
            }
            
        },
        delBindRelation:{   //绑定商品-删除绑定关系
            dialogMsg:'Are you sure to remove the binding between the ESL {mac} and the product {id}?',
            dialogTitle:'Delete',
            success:'Deleting the binding relationship between the ESL and the products is successful!',
            fail:'Deleting the binding relationship between the ESL and the products failed!',
            noBindRelation:'The binding relationship has been deleted, no need to operate again!'
        },
        dialogLabelUpdateAll:{ //标签管理-更新当前门店所有标签弹框
            dialogTitle:'Update',
            dialogMsg:'Are you sure you want to update all the ESL in your current store?',
            success:'All update instructions are sent successfully, please refresh the page to get the latest data!',
            fail:'All update instructions failed to send!',
            hint:'The ESL update is currently in progress, please wait for the ESL update to complete again!',
            input:'Please import the ESL first!'
        },
        dialogBindUpdateAll:{ //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle:'Bind',
            dialogMsg:'Are you sure to bind all the ESL in the current store to the gateway?',
            success:'All binding instructions are sent successfully, please refresh the page to get the latest status!',
            fail:'All binding instructions failed to send!',
            input:'Please import the ESL first!'
        },
        dialogRebind:{ //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle:'Bind',
            gateway:'Gateway ',
            dialogMsg:'Are you sure you want to rebind all unbound ESL in the current store?',
            success:'Send rebinding instruction to gateway successfully',
            fail:'Failed to send rebinding instructions to the gateway',
            isSend:'The gateway is busy, please wait for the gateway to finish processing before resending the instruction',
            isHaveGateway:'Please add a gateway first'
        },
        dialogUpgradeAll:{ //标签管理-批量升级
            dialogTitle:'Upgrade',
            input:'Please import the ESL first!',
            versionInfoFail:'Querying the ESL firmware version number failed',
            upgradeSuccess:'The upgrade command is sent successfully. In the ESL firmware upgrade, please keep the gateway online...',
            upgradeFail:'Upgrade command failed to send',
            versionNotEmpty:'Firmware version cannot be empty',
            macNotEmpty:'Mac address cannot be empty',
            version:'Firmware version',
            mac:'Mac address',
            tip:'Please select',
            hint:'Please select the ESL to upgrade first!',
            fail1:'The ESL is not bound to the gateway!',
            fail2:'ESL does not exist!',
            label:'ESL ',
            noPermission:'Upgrade failed, no permissions'
        },
        dialogUpgradeOne:{
            upgradeESL:'Upgrade',
            dialogTitle:'Upgrade',
            tip:'This feature will upgrade the current ESL firmware version',
            upgradeSuccess:'The upgrade command is sent successfully. In the ESL firmware upgrade, please keep the gateway online...',
            upgradeFail:'Upgrade command failed to send',
            notExist:'ESL firmware upgrade package does not exist',
            notBind:'The current ESL does not have a binding gateway.',
            notEsl:'ESL does not exist',
            noPermission:'Upgrade failed, no permissions',
            chooseLabel:'Please select the ESL to upgrade',
            noType:'The ESL does not have a corresponding type of firmware upgrade package.'
        },
        dialogBindUpdatePart:{ //标签管理-绑定标签弹框
            dialogTitle:'Bind',
            dialogMsg:'Are you sure to bind the selected ESL?',
            hint:'Please select the ESL to be bound to the gateway first!',
            success:'The batch binding command was sent successfully. Please refresh the page to get the latest data!',
            fail:'Batch binding instructions failed to send!'
        },
        dialogLabelUpdatePart:{ //标签管理-更新选中标签弹框
            dialogTitle:'Update',
            dialogMsg:'Are you sure to update the selected ESL?',
            hint:'Please select the ESL to update first!',
            success:'The batch update command was sent successfully. Please refresh the page to get the latest data!',
            fail:'Batch update command failed to send!',
            fail1:'The ESL is not bound to the gateway',
            fail2:'No corresponding ESL have been imported!',
            fail3:'The template bound to the ESL is an empty template!',
            fail4:'The ESL has no bound items!',
            fail5:'The template bound to the ESL does not exist!',
            fail6:'The ESL bound item does not exist!',
            label:'ESL '
        },
        dialogReset:{ //标签管理-复位标签弹框
            dialogTitle:'Reset',
            dialogMsg:'Are you sure to reset the selected ESL?',
            hint:'Please select the ESL to be reset first!',
            success:'The batch reset command was sent successfully. Please refresh the page to get the latest data!',
            fail:'Batch reset command failed to send!',
            fail1:'The ESL is not bound to the gateway!',
            fail2:'ESL does not exist!',
            label:'ESL '
        },
        dialogRouseAll:{ //标签管理-唤醒选中标签弹框
            dialogTitle:'Wake up',
            dialogMsg:'Are you sure to wake up the selected ESL?',
            hint:'Please select the ESL you want to wake up first!',
            success:'The batch wakeup command was sent successfully. Please refresh the page to get the latest status!',
            fail:'Batch wakeup command failed to send!'
        },
        dialogDelAll:{ //标签管理-删除选中标签弹框
            dialogTitle:'Delete',
            dialogMsg:'Are you sure to delete the selected ESL?',
            hint:'Please select the ESL you want to delete first!',
            success:'Batch delete ESL successfully!',
            fail:'Batch delete ESL failed!',
            noPermission:'Batch delete ESL failed,no permission!'
        },
        dialogBindUpdate:{ //标签管理-绑定弹框
            dialogTitle:'Bind',
            dialogMsg:'Are you sure to bind the ESL with the mac address {mac}?',
            success:'The binding command was sent successfully. Please refresh the page to get the latest status!',
            // noDevice:'No gateway detected this device!',
            fail:'The binding instruction failed to send!'
        },
        dialogRouse:{ //标签管理-唤醒弹框
            dialogTitle:'Wake up',
            dialogMsg:'Are you sure to wake up the ESL with the mac address {mac}?',
            success:'The wake-up command was sent successfully. Please refresh the page to get the latest status!',
            unbind:'The ESL does not have a binding gateway!',
            fail:'Wakeup command failed to send!'
        },
        dialogDel:{ //标签管理-删除弹框
            dialogTitle:'Delete',
            dialogMsg:'Are you sure you want to delete the ESL with the mac address {mac}?',
            success:'Deleting the ESL successfully!',
            fail:'Deleting the ESL failed!',
            noDevice:'This ESL device does not exist!',
            noPermission:'Deleting the ESL failed,no permission!'
        },
        // dialogUpgrade:{ //标签管理-升级弹框
        //     dialogTitle:'升 级',
        //     dialogMsg:'确定升级当前设备吗?',
        //     chooseLabel:'请选择标签！'
        // },
        formatTime:{  //秒 转 (天 时 分)
            day:' days ',
            hour:':',
            minute:'',
        },
        getTemplateAndPro:{ //根据标签获取模板和商品数据
            unbind:'The ESL is not bound to the product',
            fail:'Failed to get ESL template and product data!',
            unbindTp:'The template bound to this ESL does not exist!'
        },
        queryLabel:{ //查询标签
            fail:'Query ESL failed!'
        },
        getPrefix:{
            fail:'Failed to get the ESL prefix'
        },
        permission:{  //数据库数据，判断权限，不可改动
            delLabel:'删除标签',
            addLabel:'新增标签'
        },
        upload:{
            success:'Importing ESL is complete, successful {success}, failures {fail}!',
            fail:'Importing ESL failed!',
            msg:'Upload files can only be Excel spreadsheets',
            noPermission:'Failed to import ESL without permission！',
            downloadText: 'Download the import processing result file'
        },
        uploadBindRelation:{
            success:'Import is complete, successful {success}, failed {fail}!',
            fail:'Import failed!',
            msg:'Upload files can only be Excel spreadsheets'
        },
        labelFilter:{
            label:'ESL',
            deviceState:'Device status',
            allDevice:'All device',
            labelStatus:{
                online:'Online',
                offline:'Offline',
                bindGateway:'Bind',
                unbindGateway:'Unbind',
                lowPower:'Low power'
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/label.js